import { SUPPORTED_LANGUAGES } from '@d-id/types';
import styled from '@emotion/styled';
import { Typography } from '@mui/material';
import { getFlag } from '../../utils/ui';

const LanguageContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;
`;

const Img = styled.img`
    width: 20px;
    height: 14px;
`;

const LanguageLabel = styled(Typography)`
    text-transform: capitalize;
    color: ${({ theme }) => theme.colors.black[700]};
    font-weight: 500;
`;

interface IProps {
    language?: string;
}

function SourceLanguageLabel({ language }: IProps) {
    return (
        <LanguageContainer>
            {getFlag(Img, SUPPORTED_LANGUAGES[language?.trim()?.toLowerCase() || ''])}
            <LanguageLabel variant="body2">{language ? `${language} (Source)` : 'Source'}</LanguageLabel>
        </LanguageContainer>
    );
}

export default SourceLanguageLabel;
